var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-center" },
    [
      _c("b-spinner", {
        attrs: { variant: _vm.variant, label: "Text Centered" },
      }),
      _vm.message
        ? _c("span", { staticClass: "ml-1" }, [_vm._v(_vm._s(_vm.message))])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }